export function removeQueryStringParameter(pname) {
	let r = new RegExp(`[\?\&](${pname}=[^\&]+(\&|$))`);
	let m = r.exec(window.location.search);
	if (m) {
		let search = window.location.search.replace(m[1], '');
		search = search.replace(/\&$/, '');
		if (search == '?') {
			search = '';
		}
		window.history.replaceState({}, document.title, window.location.pathname + search);
	}
}

export function clearQueryStringParameters(url) {
	let replacedUrl = url.split(/[?#]/)[0];
	window.history.replaceState({}, document.title, replacedUrl);
}

export function extractUrlParameters(params) {
	let result = {};
	try {
		result = JSON.parse(
			'{"' +
			decodeURIComponent(params.substring(1))
				.replace(/"/g, '\\"')
				.replace(/&/g, '","')
				.replace(/=/g, '":"')
				.replace(/\+/g, ' ')
				.replace(/#/g, '')
				.replace(/%2F/g, '/') +
			'"}'
		);
	}
	catch {}
	return result;
}

export function navigateOneLevelUp() {
	window.location.pathname = window.location.pathname.replace(/[^\/]+\/?$/, '');
}

export function decodefacetStringHash(hash) {
	const decodedHash = decodeURIComponent(hash);
	const regex = /#&currentPage=\d{1,10}&facetStrings=/gm;
	return decodedHash.replace(regex, '');
}

export function getUrlHashPropertyValue(hash, key) {
	const formattedHash = decodeURIComponent(hash);
	const obj = formattedHash.split('&').reduce((res, item) => {
		const parts = item.split('=');
		res[parts[0]] = parts[1];
		return res;
	}, {});
	return obj ? obj[key] : '';
}

export function getQueryStringObject() {
	const params = new URLSearchParams(window.location.search);
	const queryStringObj = {};
	for (const [key, value] of params) {
		queryStringObj[key] = value;
	}
	return queryStringObj;
}
